/**
 * Created by Sky
 */
/**
 * 將字串左邊補特定字串，補足位數
 * @param {string} paddingStr
 * @param {string} str
 * @param {number} length
 * @returns {string}
 */
export function paddingLeftByStr(paddingStr, str, length) {
  // console.log(`paddingStr : ${paddingStr}, str : ${str}, str.length : ${str.length}, length: ${length}`)
  if (str.length >= length) {
    // console.log(`return  ${str}`)
    return str
  } else {
    // console.log(`return  ${paddingLeftByStr(paddingStr, paddingStr + str, length)}`)
    return paddingLeftByStr(paddingStr, paddingStr + str, length)
  }
}
